import { createBrowserRouter } from "react-router-dom";

import AdminLayout from "./Pages/AdminInterface/AdminInterface";
import ErrorPage from "./Pages/ErrorPage";

//#Protected layouts
import ProtectedLayout from "utils/ProtectedLayout";
import ProtectedMypagesLayout from "utils/ProtectedMypagesLayout";

//#Login
import LoginPage, { action as loginAction } from "./Pages/Login/LoginPage";

//<------------------------Admin interface ----------------------------->

//#DASHBOARD
import { Dashboard as AdminDashboard } from "Pages/AdminInterface/dashboard/Dashboard";

//#users
import { Users } from "Pages/AdminInterface/users/Users";
import { User as UserPage } from "./Pages/AdminInterface/users/user/User";
import { UserCard as UserView } from "Pages/AdminInterface/users/user/usercard/UserCard";
import { CreateUser } from "Pages/AdminInterface/users/CreateUser";

//#CLIENTS
import { Clients } from "Pages/AdminInterface/clients/Clients";
import CreateClientView from "./Pages/AdminInterface/clients/CreateClient";
import { Client } from "Pages/AdminInterface/clients/client/Client";
import { Invoices as ClientsInvoices } from "Pages/AdminInterface/clients/client/invoices/Invoices";
import { Endcustomers as ClientsEndcustomers } from "Pages/AdminInterface/clients/client/endcustomers/Endcustomers";
import { AccountsLedger as ClientAccountsLedger } from "Pages/AdminInterface/clients/client/accountsledger/accountsledger";

//#ENDCUSTOMERS
import { Endcustomers } from "Pages/AdminInterface/endcustomers/Endcustomers";
import { CreateEndCustomer } from "Pages/AdminInterface/endcustomers/CreateEndCustomer";

import { Endcustomer } from "Pages/AdminInterface/endcustomers/endcustomer/Endcustomer";
import EndCustomerCard from "Pages/AdminInterface/endcustomers/endcustomer/endcustomerCard/EndCustomerCard";
import EndcustomerInvoices from "Components/Endcustomer/Workflows/EndcustomerInvoices";
import { AccountsLedger as EndcustomerAccountsLedger } from "Pages/AdminInterface/endcustomers/endcustomer/accountledger/AccountsLedger";

//#INVOICES
import { Invoices } from "Pages/AdminInterface/invoices/Invoices";
import { CreateInvoice } from "Pages/AdminInterface/invoices/CreateInvoice";
import { Invoice as InvoicePage } from "./Pages/AdminInterface/invoices/invoice/Invoice";

//#CLIENTACCOUNTS
import ClientsAccounts from "Pages/AdminInterface/clientsaccounts/ClientsAccounts";
import CreateClientAccount from "Pages/AdminInterface/clientsaccounts/CreateClientAccount";
import ClientAccount from "Pages/AdminInterface/clientsaccounts/clientaccount/ClientAccount";

//#ENDCUSTOMERACCOUNTS
import EndcustomersAccounts from "Pages/AdminInterface/endcustomersaccounts/EndcustomersAccounts";
import CreateEndcustomerAccount, {
  loader as CreateEndcustomerAccountLoader,
} from "Pages/AdminInterface/endcustomersaccounts/CreateEndcustomerAccount";
import EndcustomerAccount, {
  loader as endCustomerAccountLoader,
} from "Pages/AdminInterface/endcustomersaccounts/endcustomeraccount/EndcustomerAccount";
import EndcustomerAccountCard from "Pages/AdminInterface/endcustomersaccounts/endcustomeraccount/endcustomeraccountcard/EndcustomerAccountCard";

//#CLIENTARTICLES
import ClientsArticles from "Pages/AdminInterface/clientsarticles/ClientsArticles";
import CreateClientArticle from "Pages/AdminInterface/clientsarticles/create/CreateClientArticle";
import ClientArticle from "Pages/AdminInterface/clientsarticles/clientarticle/ClientArticle";

//#ENDCUSTOMERARTICLES
import EndcustomerArticles from "Pages/AdminInterface/endcustomersarticles/EndcustomersArticles";
import CreateEndcustomerArticle from "Pages/AdminInterface/endcustomersarticles/create/CreateEndcustomerArticle";
import EndcustomerArticle from "Pages/AdminInterface/endcustomersarticles/endcustomerarticle/EndcustomerArticle";

//#OPTIONS
import {
  Options,
  loader as optionsLoader,
} from "Pages/AdminInterface/options/Options";
import {
  CreateOption,
  loader as createOptionLoader,
} from "Pages/AdminInterface/options/CreateOption";
import Option, {
  loader as editOptionLoader,
} from "Pages/AdminInterface/options/option/Option";

// Workflows
import { Workflows } from "Pages/AdminInterface/workflows/Workflows";

//#SYSTEM
import {
  System,
  loader as systemLoader,
} from "Pages/AdminInterface/system/System";

//#ENDCUSTOMERPAID
import { EndCustomerPaid } from "Pages/AdminInterface/endcustomerpaid/EndCustomerPaid";
import {
  CreateEndCustomerPaid,
  loader as createEndCustomerPaidLoader,
} from "Pages/AdminInterface/endcustomerpaid/CreateEndCustomerPaid";
import {
  EndCustomerPaidPage,
  loader as endCustomerPaidPageLoader,
} from "./Pages/AdminInterface/endcustomerpaid/components/EndCustomerPaidPage";
import { EndCustomerPaidCard } from "./Pages/AdminInterface/endcustomerpaid/components/EndCustomerPaidCard";
import { EndCustomerPaidMatching } from "Pages/AdminInterface/endcustomerpaid/EndCustomerPaidMatching";

//#ENDCUSTOMERPRINTED
import { EndCustomerPrinted } from "Pages/AdminInterface/endcustomerprinted/EndCustomerPrinted";
import {
  CreateEndCustomerPrinted,
  loader as createEndCustomerPrintedLoader,
} from "Pages/AdminInterface/endcustomerprinted/CreateEndCustomerPrinted";
import {
  EndCustomerPrintedPage,
  loader as endCustomerPrintedPageLoader,
} from "./Pages/AdminInterface/endcustomerprinted/components/EndCustomerPrintedPage";
import { EndCustomerPrintedCard } from "./Pages/AdminInterface/endcustomerprinted/components/EndCustomerPrintedCard";

//#CLIENTBANKFILE
import { ClientPayments } from "Pages/AdminInterface/clientpayments/ClientPayments";
import { CreateClientPayment } from "Pages/AdminInterface/clientpayments/CreateClientPayment";
import { ClientPaymentPage } from "./Pages/AdminInterface/clientpayments/components/ClientPaymentPage";
import { ClientPaymentCard } from "./Pages/AdminInterface/clientpayments/components/ClientPaymentCard";

//#CLIENTINVOICEBUNDLE
import {
  ClientInvoiceBundle,
  loader as clientInvoiceBundleLoader,
} from "Pages/AdminInterface/clientinvoicebundle/ClientInvoiceBundle";
import {
  CreateClientInvoiceBundle,
  loader as createClientInvoiceBundleLoader,
} from "Pages/AdminInterface/clientinvoicebundle/CreateClientInvoiceBundle";
import {
  ClientInvoiceBundlePage,
  loader as clientInvoiceBundlePageLoader,
} from "./Pages/AdminInterface/clientinvoicebundle/components/ClientInvoiceBundlePage";
import { ClientInvoiceBundleCard } from "./Pages/AdminInterface/clientinvoicebundle/components/ClientInvoiceBundleCard";

//#FILES
import { Files } from "Pages/AdminInterface/files/Files";
import { UploadFiles } from "Pages/AdminInterface/files/UploadFiles";
import { FilesPage } from "./Pages/AdminInterface/files/components/FilesPage";

//<------------------------MYPAGES interface ----------------------------->
import Home from "./Pages/ClientInterface/Home";
//#DASHBOARD

import { MyPages } from "Pages/ClientInterface/mypages/MyPages";
import { MyPagesCard } from "Pages/ClientInterface/mypages/MyPagesCard";

import { Books } from "Pages/AdminInterface/books/Books";
import {
  BooksPage,
  loader as booksPageLoader,
} from "Pages/AdminInterface/books/componentes/BooksPage";
import { BooksCard } from "Pages/AdminInterface/books/componentes/BooksCard";
import { CreateBooks } from "Pages/AdminInterface/books/CreateBooks";
import ProcessInvoices from "Pages/AdminInterface/invoices/processInvoices/ProcessInvoices";
import CollectionInvoices from "Pages/AdminInterface/invoices/export/CollectionInvoices";
import { AccountCharts } from "Pages/AdminInterface/accountcharts/AccountCharts";
import {
  AccountChartsLayout,
  BalancesLayout,
  BookingLayout,
  ClientAccountLayout,
  ClientPaymentsLayout,
  ClientsArticlesLayout,
  ClientsLayout,
  EndCustomerLayout,
  EndCustomerPaymentBundlesLayout,
  EndCustomersArticlesLayout,
  EndCustomerUnplacedLayout,
  InvoicesLayout,
  MyPagesEndCustomerLayout,
} from "routerLayouts";
import { CreateAccountChart } from "Pages/AdminInterface/accountcharts/CreateAccountChart";
import { AccountChartPage } from "Pages/AdminInterface/accountcharts/components/AccountChartPage";
import Verify from "Pages/AdminInterface/verify/Verify";
import Verified from "Pages/AdminInterface/verified/Verified";
import { MyPageInvoiceCard } from "Pages/ClientInterface/mypages/MyPageInvoiceCard";
import ChangePassword from "Pages/ClientInterface/ChangePassword/ChangePassword";
import { Balances } from "Pages/AdminInterface/balances/Balances";
import { BalancePage } from "Pages/AdminInterface/balances/componentes/BalancePage";
import { CompanySettings } from "Pages/AdminInterface/companysettings/CompanySettings";
import EndcustomerUnplaced from "Pages/AdminInterface/endcustomerunplaced/EndcustomerUnplaced";
import { ClientPaymentsDraft } from "Pages/AdminInterface/clientpaymentsdraft/ClientPaymentsDraft";
import ProcessInterestInvoices from "Pages/AdminInterface/invoices/processInvoices/ProcessInterestInvoices";
import ProcessReminders from "Pages/AdminInterface/invoices/processInvoices/ProcessReminders";
import { EndCustomerPaymentBundles } from "Pages/AdminInterface/endcustomerpaymentbundles/EndCustomerPaymentBundles";
import { EndCustomerPaymentBundlePage } from "Pages/AdminInterface/endcustomerpaymentbundles/EndCustomerPaymentBundlePage";
import RemindersTable from "Pages/AdminInterface/endcustomersaccounts/RemindersTable";
import { SieExport } from "Pages/AdminInterface/books/SieExport";
import { InternalReports } from "Pages/AdminInterface/reports/InteralReports";

const router = (login) => {
  return createBrowserRouter([
    {
      element: <ProtectedLayout />,
      errorElement: <ErrorPage />,
      children: [
        {
          element: <AdminLayout />,
          children: [
            {
              path: "/",
              element: <AdminDashboard />,
              index: true,
            },
            {
              path: "dashboard",
              element: <AdminDashboard />,
              id: "adminDashboard",
            },
            {
              path: "users",
              children: [
                {
                  index: true,
                  element: <Users />,
                },
                {
                  path: ":userID",
                  element: <UserPage />,
                  RouteName: "USER",
                  id: "user",
                  children: [{ index: true, element: <UserView /> }],
                },
                {
                  path: "create",
                  element: <CreateUser />,
                },
              ],
            },
            {
              path: "clients",
              element: <ClientsLayout />,
              children: [
                {
                  index: true,
                  element: <Clients />,
                },
                {
                  path: ":clientID",
                  element: <Client />,
                  id: "client",
                  children: [
                    {
                      path: "invoices",
                      element: <ClientsInvoices />,
                    },
                    {
                      path: "endcustomers",
                      element: <ClientsEndcustomers />,
                    },
                    {
                      path: "accountsledger",
                      element: <ClientAccountsLedger />,
                    },
                  ],
                },
                {
                  path: "create",
                  element: <CreateClientView />,
                },
              ],
            },
            {
              path: "endcustomers",
              element: <EndCustomerLayout />,
              children: [
                {
                  index: true,
                  element: <Endcustomers />,
                },
                {
                  path: ":endcustomerID",
                  element: <Endcustomer />,
                  id: "endCustomer",
                  children: [
                    {
                      index: true,
                      element: <EndCustomerCard />,
                    },
                    {
                      path: "invoices",
                      element: <EndcustomerInvoices />,
                    },
                    {
                      path: "accountsledger",
                      element: <EndcustomerAccountsLedger />,
                    },
                  ],
                },
                {
                  path: "create",
                  element: <CreateEndCustomer />,
                },
              ],
            },
            {
              path: "reminders",
              children: [
                {
                  index: true,
                  element: <RemindersTable />,
                },
              ],
            },
            {
              path: "interestinvoices",
              children: [
                {
                  index: true,
                  element: <Workflows />,
                },
              ],
            },
            {
              path: "invoices",
              element: <InvoicesLayout />,
              children: [
                {
                  index: true,
                  element: <Invoices />,
                },
                {
                  path: ":invoiceID",
                  element: <InvoicePage />,
                  id: "invoice",
                },
                {
                  path: "process",
                  element: <ProcessInvoices />,
                },
                {
                  path: "collection",
                  element: <CollectionInvoices />,
                },
                {
                  path: "create",
                  element: <CreateInvoice />,
                },
                {
                  path: "interest",
                  element: <ProcessInterestInvoices />,
                },
                {
                  path: "reminder",
                  element: <ProcessReminders />,
                },
              ],
            },
            {
              path: "clientsaccounts",
              element: <ClientAccountLayout />,
              children: [
                {
                  index: true,
                  element: <ClientsAccounts />,
                },
                {
                  path: "create",
                  element: <CreateClientAccount />,
                },
                {
                  path: ":accountID",
                  element: <ClientAccount />,
                  id: "clientAccount",
                },
              ],
            },
            {
              path: "endcustomersaccounts",
              children: [
                {
                  index: true,
                  element: <EndcustomersAccounts />,
                },
                {
                  path: "create",
                  element: <CreateEndcustomerAccount />,
                  loader: CreateEndcustomerAccountLoader,
                },
                {
                  path: ":accountID",
                  element: <EndcustomerAccount />,
                  loader: endCustomerAccountLoader,
                  id: "endcustomerAccount",
                  children: [
                    { index: true, element: <EndcustomerAccountCard /> },
                  ],
                },
              ],
            },
            {
              path: "clientsarticles",
              element: <ClientsArticlesLayout />,
              children: [
                {
                  index: true,
                  element: <ClientsArticles />,
                },
                {
                  path: "create",
                  element: <CreateClientArticle />,
                },
                {
                  path: ":articleID",
                  element: <ClientArticle />,
                  id: "clientArticle",
                },
              ],
            },
            {
              path: "endcustomersarticles",
              element: <EndCustomersArticlesLayout />,
              children: [
                {
                  index: true,
                  element: <EndcustomerArticles />,
                },
                {
                  path: "create",
                  element: <CreateEndcustomerArticle />,
                },
                {
                  path: ":articleID",
                  element: <EndcustomerArticle />,
                },
              ],
            },
            {
              path: "endcustomerunplaced",
              element: <EndCustomerUnplacedLayout />,
              children: [
                {
                  index: true,
                  element: <EndcustomerUnplaced />,
                },
              ],
            },
            {
              path: "options",
              children: [
                {
                  index: true,
                  element: <Options />,
                  loader: optionsLoader,
                },
                {
                  path: "create",
                  element: <CreateOption />,
                  loader: createOptionLoader,
                },
                {
                  path: ":optionID",
                  element: <Option />,
                  loader: editOptionLoader,
                },
              ],
            },
            {
              path: "system",
              children: [
                {
                  index: true,
                  element: <System />,
                  loader: systemLoader,
                },
              ],
            },
            {
              path: "workflows",
              children: [
                {
                  index: true,
                  element: <Workflows />,
                },
              ],
            },
            {
              path: "companysettings",
              children: [
                {
                  index: true,
                  element: <CompanySettings />,
                },
              ],
            },
            {
              path: "endcustomerpaid",
              children: [
                {
                  index: true,
                  element: <EndCustomerPaid />,
                },
                {
                  path: ":paidID",
                  element: <EndCustomerPaidPage />,
                  loader: endCustomerPaidPageLoader,
                  id: "paid",
                  children: [
                    {
                      index: true,
                      element: <EndCustomerPaidCard />,
                    },
                  ],
                },
                { path: "matching", element: <EndCustomerPaidMatching /> },
                {
                  path: "create",
                  element: <CreateEndCustomerPaid />,
                  loader: createEndCustomerPaidLoader,
                },
              ],
            },
            {
              path: "endcustomerprinted",
              children: [
                {
                  index: true,
                  element: <EndCustomerPrinted />,
                },
                {
                  path: ":printedID",
                  element: <EndCustomerPrintedPage />,
                  loader: endCustomerPrintedPageLoader,
                  id: "printed",
                  children: [
                    {
                      index: true,
                      element: <EndCustomerPrintedCard />,
                    },
                  ],
                },
                {
                  path: "create",
                  element: <CreateEndCustomerPrinted />,
                  loader: createEndCustomerPrintedLoader,
                },
              ],
            },
            {
              path: "endcustomerpaymentbundles",
              element: <EndCustomerPaymentBundlesLayout />,
              children: [
                {
                  index: true,
                  element: <EndCustomerPaymentBundles />,
                },
                {
                  path: ":paymentBundleID",
                  element: <EndCustomerPaymentBundlePage />,
                  id: "paymentbundle",
                  children: [
                    {
                      index: true,
                      element: null,
                    },
                  ],
                },
              ],
            },
            {
              path: "clientpayments",
              element: <ClientPaymentsLayout />,
              children: [
                {
                  index: true,
                  element: <ClientPayments />,
                },
                {
                  path: ":paymentID",
                  element: <ClientPaymentPage />,
                  id: "clientpayment",
                  children: [
                    {
                      index: true,
                      element: <ClientPaymentCard />,
                    },
                  ],
                },
                {
                  path: "create",
                  element: <CreateClientPayment />,
                },
              ],
            },
            {
              path: "clientpaymentsdraft",
              element: <ClientPaymentsLayout />,
              children: [
                {
                  index: true,
                  element: <ClientPaymentsDraft />,
                },
              ],
            },
            {
              path: "clientinvoicebundle",
              children: [
                {
                  index: true,
                  loader: clientInvoiceBundleLoader,
                  element: <ClientInvoiceBundle />,
                },
                {
                  path: ":bundleID",
                  element: <ClientInvoiceBundlePage />,
                  loader: clientInvoiceBundlePageLoader,
                  id: "bundle",
                  children: [
                    {
                      index: true,
                      element: <ClientInvoiceBundleCard />,
                    },
                  ],
                },
                {
                  path: "create",
                  element: <CreateClientInvoiceBundle />,
                  loader: createClientInvoiceBundleLoader,
                },
              ],
            },
            {
              path: "books",
              element: <BookingLayout />,
              children: [
                {
                  index: true,
                  element: <Books />,
                },
                {
                  path: ":booksID",
                  element: <BooksPage />,
                  loader: booksPageLoader,
                  id: "books",
                  children: [
                    {
                      index: true,
                      element: <BooksCard />,
                    },
                  ],
                },
                {
                  path: "create",
                  element: <CreateBooks />,
                },
                {
                  path: "sie",
                  element: <SieExport />,
                },
              ],
            },
            {
              path: "balances",
              element: <BalancesLayout />,
              children: [
                {
                  index: true,
                  element: <Balances />,
                },
                {
                  path: ":balanceId",
                  element: <BalancePage />,
                  id: "balance",
                },
              ],
            },
            {
              path: "accountcharts",
              element: <AccountChartsLayout />,
              children: [
                {
                  index: true,
                  element: <AccountCharts />,
                },
                {
                  path: "create",
                  element: <CreateAccountChart />,
                },

                {
                  path: ":accountChartId",
                  element: <AccountChartPage />,
                  id: "accountChart",
                },
              ],
            },
            {
              path: "files",
              children: [
                {
                  index: true,
                  element: <Files />,
                },
                {
                  path: ":fileID",
                  element: <FilesPage />,
                  id: "file",
                },
                {
                  path: "upload",
                  element: <UploadFiles />,
                },
              ],
            },
            {
              path: "reports",
              element: <InternalReports />,
            },
            {
              path: "verify",
              children: [
                {
                  path: ":uuid",
                  element: <Verify />,
                },
              ],
            },
            {
              path: "verified",
              children: [
                {
                  index: true,
                  element: <Verified />,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      path: "login",
      element: <LoginPage />,
      action: loginAction(login),
    },
    {
      element: <ProtectedMypagesLayout />,
      children: [
        {
          element: <Home />,
          children: [
            {
              path: "mypages",
              element: <MyPages />,
              id: "mypages",
              children: [
                {
                  index: true,
                  element: <MyPagesCard />,
                },
              ],
            },
            {
              path: "clientInvoices",
              children: [
                { path: ":invoiceID", element: <MyPageInvoiceCard /> },
              ],
            },
            {
              path: "changepassword",
              element: <ChangePassword />,
            },
            {
              path: "mypages/verify",
              children: [
                {
                  path: ":uuid",
                  element: <Verify fromMyPages />,
                },
              ],
            },
            {
              path: "mypages/verified",
              children: [
                {
                  index: true,
                  element: <Verified fromMyPages />,
                },
              ],
            },
            {
              path: "mypages/endcustomers",
              element: <MyPagesEndCustomerLayout />,
              children: [
                {
                  path: ":endcustomerID",
                  element: <Endcustomer />,
                  id: "endcustomerID",
                },
              ],
            },
          ],
        },
      ],
    },
  ]);
};
export default router;
